import type { ReactNode } from 'react'
import { AccessDenied } from '../AccessDenied'
import { useCanAccess } from '../useCanAccess'

export interface RequireAccessProps {
  resource: string
  action: string
  children: ReactNode
}

/** Route gate: the element when allowed, otherwise the access-denied view (the user stays signed in). */
export function RequireAccess({ resource, action, children }: RequireAccessProps) {
  return useCanAccess(resource, action) ? children : <AccessDenied />
}
